import React, { Component } from 'react';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';

import { Link } from 'react-router-dom';
import Layout from '../layout';

import styles from '../styles/pages/checkout-fail-page.scss';

class CheckoutFailPage extends Component {
    constructor(props) {
        super(props);
        this.renderTimeOutErrorMsg = this.renderTimeOutErrorMsg.bind(this);
        this.renderInternalErrorMsg = this.renderInternalErrorMsg.bind(this);

        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
    }

    componentDidMount() {
        this.props.clearOrder();
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        }
    }

    // eslint-disable-next-line class-methods-use-this
    renderTimeOutErrorMsg() {
        return (
            <div>
                <h3 className={styles.checkoutMsg}>
                    <FormattedMessage id="thank-for-your-buy" defaultMessage="Thanks for your buy" />
                </h3>
                <p className="margin-top-20">
                    <FormattedMessage id="fail-confirmation-1-message" defaultMessage="Thanks for your buy" />
                </p>
                <p style={{ marginTop: 3 }}>
                    <FormattedMessage id="fail-confirmation-2-message" defaultMessage="Otherwise we suggest to repeat the purchase" />
                </p>
                <p className="" style={{ marginTop: 3 }}>
                    <FormattedMessage id="fail-confirmation-3-message" defaultMessage="Thanks for your buy" />
                </p>
                <p className="margin-top-20" style={{ marginTop: 3 }}>
                    <FormattedMessage id="fail-confirmation-4-message" defaultMessage="Thanks for your buy" />
                </p>
                <p style={{ marginTop: 3 }}>
                    <FormattedHTMLMessage id="fail-confirmation-5-message" defaultMessage="and our Shipping Policies and Charges" />
                </p>
                <p style={{ marginTop: 3 }}>
                    <Link to="frequent-questions" className={styles.link}>https://www.katapulk.com/frequent-questions</Link>
                </p>
                <p style={{ marginTop: 3 }}>
                    <FormattedHTMLMessage id="fail-confirmation-6-message" defaultMessage="and our Shipping Policies and Charges" />
                </p>
                <p style={{ marginTop: 3 }}>
                    <Link to="shipping-policy" className={styles.link}>https://www.katapulk.com/shipping-policy</Link>
                </p>
                <p className="margin-top-20">
                    <strong>
                        <FormattedMessage id="katapulk-team" defaultMessage="Support Team" />
                    </strong>
                </p>
            </div>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    renderInternalErrorMsg() {
        return (
            <div>
                <h3 className={styles.checkoutMsg}>
                    <FormattedMessage id="sorry-error-occurred-title" defaultMessage="" />
                </h3>
                <p className="margin-top-20 text-center">
                    <FormattedMessage id="error-general-message" defaultMessage="An error occurred" />
                </p>
                <p className="margin-top-20 text-center">
                    <strong>
                        <FormattedMessage id="katapulk-team" defaultMessage="Support Team" />
                    </strong>
                </p>
            </div>
        );
    }

    render() {
        return (
            <Layout>
                <div className="checkout-flow checkout-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="checkout-confirmation-block" />
                                        {this.props.placedOrder.orderError === 'timeout'
                                            ? this.renderTimeOutErrorMsg()
                                            : this.renderInternalErrorMsg()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(CheckoutFailPage);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/checkout-fail-page.jsx
 **/